import { FONT } from "@/styles/common";
import { Box, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomBox = styled(Box)`
    & .carousel .control-dots {
        & .dot {
            width: 16px;
            height: 16px;
            box-shadow: none;
        }
    }
`;

export const CustomTitle = styled(Text)`
    ${FONT("cormorant", 52, 700)}

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        ${FONT("cormorant", 32, 700)}
    }
`;

export const CustomText = styled(Text)`
    ${FONT("notoSerif", 16, 500)}

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        ${FONT("cormorant", 14, 700)}
    }
`;
